// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button-module--Button--2YI99"};